import React, { useState } from "react";

import "./styles.less";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { Title } from "../../components/Title";
import { CardModal } from "../../components/CardModal";

export const CustomerStorys = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [currentCardText, setCurrentCardText] = useState(null);
  const nav = useNavigate();
  const cardListOne = [
    {
      cardHeight: "490px",
      imgUrl: "//files.authing.co/authing-website/brand-toyota-red.svg",
      cardTitle: t("customer.home.cardList.item1.title"),
      cardText: t("customer.home.cardList.item1.text"),
      cardAllText: t("customer.home.cardList.item1.allText"),
    },
    {
      cardHeight: "450px",
      imgUrl: "//files.authing.co/authing-website/brand-logo-zhaoshang.svg",
      cardTitle: t("customer.home.cardList.item2.title"),
      cardText: t("customer.home.cardList.item2.text"),
      cardAllText: t("customer.home.cardList.item2.allText"),
    },
    {
      cardHeight: "450px",
      imgUrl: "//files.authing.co/authing-website/home-logo-kingdee-new.png",
      cardTitle: t("customer.home.cardList.item3.title"),
      cardText: t("customer.home.cardList.item3.text"),
      cardAllText: t("customer.home.cardList.item3.allText"),
    },
    {
      cardHeight: "400px",
      imgUrl: "//files.authing.co/authing-website/home-logo-yuanqi-forest.png",
      cardTitle: t("customer.home.cardList.item14.title"),
      cardText: t("customer.home.cardList.item14.text"),
      cardAllText: t("customer.home.cardList.item14.allText"),
    },
  ];
  const cardListTwo = [
    // {
    //   cardHeight: "340px",
    //   imgUrl: "//files.authing.co/authing-website/home-logo-dongnan-new.png",
    //   cardTitle: t("customer.home.cardList.item4.title"),
    //   cardText: t("customer.home.cardList.item4.text"),
    //   cardAllText: t("customer.home.cardList.item4.allText"),
    //   link:"/customer/southeast-university",
    // },
    // {
    //   cardHeight: "390px",
    //   imgUrl: "//files.authing.co/authing-website/home-logo-bentley-new.png",
    //   cardTitle: t("customer.home.cardList.item5.title"),
    //   cardText: t("customer.home.cardList.item5.text"),
    //   cardAllText: t("customer.home.cardList.item5.allText"),
    //   link:"/customer/bentley",
    //   imgWidth:"144px"
    // },
    {
      cardHeight: "340px",
      imgUrl: "//files.authing.co/authing-website/home-ey.png",
      cardTitle: t("customer.home.cardList.item6.title"),
      cardText: t("customer.home.cardList.item6.text"),
      cardAllText: t("customer.home.cardList.item6.allText"),
      link: "/customer/futu",
    },
    {
      cardHeight: "380px",
      imgUrl: "//files.authing.co/authing-website/home-treelab-new.png",
      cardTitle: t("customer.home.cardList.item17.title"),
      cardText: t("customer.home.cardList.item17.text"),
      cardAllText: t("customer.home.cardList.item17.allText"),
      link: "/customer/futu",
    },
    // {
    //   cardHeight: "320px",
    //   imgUrl: "//files.authing.co/authing-website/brand-theragun.svg",
    //   cardTitle: t("customer.home.cardList.item7.title"),
    //   cardText: t("customer.home.cardList.item7.text"),
    //   cardAllText: t("customer.home.cardList.item7.allText"),
    //   link: "/customer/theragun",
    // },
  ];
  const cardListThree = [
    {
      cardHeight: "400px",
      imgUrl: "//files.authing.co/authing-website/bentleymotors.png",
      cardTitle: t("customer.home.cardList.item15.title"),
      cardText: t("customer.home.cardList.item15.text"),
      cardAllText: t("customer.home.cardList.item15.allText"),
    },
  ];
  const cardListFour = [
    {
      cardHeight: "380px",
      //files.authing.co/authing-website/home-logo-pand-new.png
      imgUrl: "//files.authing.co/authing-website/home-logo-ping-cap.png",
      cardTitle: t("customer.home.cardList.item11.title"),
      cardText: t("customer.home.cardList.item11.text"),
      cardAllText: t("customer.home.cardList.item11.allText"),
    },
    {
      cardHeight: "490px",
      imgUrl: "//files.authing.co/authing-website/home-logo-jcdecaux.png",
      cardTitle: t("customer.home.cardList.item12.title"),
      cardText: t("customer.home.cardList.item12.text"),
      cardAllText: t("customer.home.cardList.item12.allText"),
    },
    {
      cardHeight: "480px",
      imgUrl: "//files.authing.co/authing-website/home-logo-tetin-new.png",

      cardTitle: t("customer.home.cardList.item13.title"),
      cardText: t("customer.home.cardList.item13.text"),
      cardAllText: t("customer.home.cardList.item13.allText"),
    },
    {
      cardHeight: "440px",
      imgUrl: "//files.authing.co/authing-website/vw.png",

      cardTitle: t("customer.home.cardList.item16.title"),
      cardText: t("customer.home.cardList.item16.text"),
      cardAllText: t("customer.home.cardList.item16.allText"),
    },
  ];
  return (
    <section>
      <div className="customer-story-warp">
        <div className="inner">
          <Title title={t("customer.home.cardList.title")} />
          <div className="story-card-warp">
            <CardModal
              visible={visible}
              setVisible={setVisible}
              imgUrl={currentCardText?.imgUrl}
              cardTitle={currentCardText?.cardTitle}
              cardText={currentCardText?.cardText}
            ></CardModal>
            <div className="card-block">
              {/* <div
                className="story-card"
                style={{ height: 490 }}
                onClick={() => {
                  nav("/customer/heigh-educate");
                }}
              >
                <div className="card-logo">
                  <img src="//files.authing.co/authing-website/brand-toyota-red.svg" alt="" />
                </div>
                <div className="card-title">{t("customer.home.cardList.item1.title")}</div>
                <div className="card-content">{t("customer.home.cardList.item1.text")}</div>
              </div> */}
              {cardListOne.map((item) => (
                <div
                  className="story-card"
                  style={{ height: item.cardHeight }}
                  onClick={() => {
                    setVisible(true);
                    setCurrentCardText({
                      imgUrl: item.imgUrl,
                      cardTitle: item.cardTitle,
                      cardText: item.cardAllText,
                    });
                  }}
                >
                  <div className="card-logo">
                    <img src={item.imgUrl} alt="authing logo" />
                  </div>
                  <div className="card-title">{item.cardTitle}</div>
                  <div className="card-content">{item.cardText}</div>
                </div>
              ))}
            </div>

            <div className="card-block">
              <div
                className="story-card"
                style={{ height: 340 }}
                onClick={() => {
                  nav("/customer/southeast-university");
                }}
              >
                <div className="card-logo">
                  <img
                    src={
                      "//files.authing.co/authing-website/home-logo-dongnan-new.png"
                    }
                    alt="authing cnpc logo"
                  />
                </div>
                <div className="card-title">
                  {t("customer.home.cardList.item4.title")}
                </div>
                <div className="card-content">
                  {t("customer.home.cardList.item4.text")}
                </div>
              </div>
              <div
                className="story-card"
                style={{ height: 390 }}
                onClick={() => {
                  nav("/customer/bentley");
                }}
              >
                <div className="card-logo">
                  <img
                    src="//files.authing.co/authing-website/home-logo-bentley-new.png"
                    alt="authing theragun logo"
                    style={{ width: "144px", padding: "18px 0px" }}
                  />
                </div>
                <div className="card-title">
                  {t("customer.home.cardList.item5.title")}
                </div>
                <div className="card-content">
                  {t("customer.home.cardList.item5.text")}
                </div>
              </div>
              {cardListTwo.map((item) => (
                <div
                  className="story-card"
                  style={{ height: item.cardHeight }}
                  onClick={() => {
                    setVisible(true);
                    setCurrentCardText({
                      imgUrl: item.imgUrl,
                      cardTitle: item.cardTitle,
                      cardText: item.cardAllText,
                    });
                  }}
                >
                  <div className="card-logo">
                    <img src={item.imgUrl} alt="authing logo" />
                  </div>
                  <div className="card-title">{item.cardTitle}</div>
                  <div className="card-content">{item.cardText}</div>
                </div>
              ))}
              <div
                className="story-card"
                style={{ height: 320 }}
                onClick={() => {
                  nav("/customer/theragun");
                }}
              >
                <div className="card-logo">
                  <img
                    src="//files.authing.co/authing-website/brand-theragun.svg"
                    alt="authing hep logo"
                  />
                </div>
                <div className="card-title">
                  {t("customer.home.cardList.item7.title")}
                </div>
                <div className="card-content">
                  {t("customer.home.cardList.item7.text")}
                </div>
              </div>
            </div>
            <div className="card-block">
              <div
                className="story-card"
                style={{ height: 460 }}
                onClick={() => {
                  nav("/customer/cnpn");
                }}
              >
                <div className="card-logo">
                  <img
                    src={
                      "//files.authing.co/authing-website/home-logo-cnpc-new.png"
                    }
                    alt="authing cnpc logo"
                  />
                </div>
                <div className="card-title">
                  {t("customer.home.cardList.item8.title")}
                </div>
                <div className="card-content">
                  {t("customer.home.cardList.item8.text")}
                </div>
              </div>
              <div
                className="story-card"
                style={{ height: 490 }}
                onClick={() => {
                  nav("/customer/hep");
                }}
              >
                <div className="card-logo">
                  <img
                    src="//files.authing.co/authing-website/home-logo-higer-new.png"
                    alt="authing hep logo"
                  />
                </div>
                <div className="card-title">
                  {t("customer.home.cardList.item9.title")}
                </div>
                <div className="card-content">
                  {t("customer.home.cardList.item9.text")}
                </div>
              </div>
              <div
                className="story-card"
                style={{ height: 440 }}
                onClick={() => {
                  setVisible(true);
                  setCurrentCardText({
                    imgUrl:
                      "//files.authing.co/authing-website/brand-state-grid.png",
                    cardTitle: t("customer.home.cardList.item10.title"),
                    cardText: t("customer.home.cardList.item10.allText"),
                  });
                }}
              >
                <div className="card-logo">
                  <img
                    src={
                      "//files.authing.co/authing-website/brand-state-grid.png"
                    }
                    alt="authing logo"
                  />
                </div>
                <div className="card-title">
                  {t("customer.home.cardList.item10.title")}
                </div>
                <div className="card-content">
                  {t("customer.home.cardList.item10.text")}
                </div>
              </div>
              {cardListThree.map((item) => (
                <div
                  className="story-card"
                  style={{ height: item.cardHeight }}
                  onClick={() => {
                    setVisible(true);
                    setCurrentCardText({
                      imgUrl: item.imgUrl,
                      cardTitle: item.cardTitle,
                      cardText: item.cardAllText,
                    });
                  }}
                >
                  <div className="card-logo">
                    <img src={item.imgUrl} alt="" />
                  </div>
                  <div className="card-title">{item.cardTitle}</div>
                  <div className="card-content">{item.cardText}</div>
                </div>
              ))}
            </div>
            <div className="card-block">
              {cardListFour.map((item) => (
                <div
                  className="story-card"
                  style={{ height: item.cardHeight }}
                  onClick={() => {
                    setVisible(true);
                    setCurrentCardText({
                      imgUrl: item.imgUrl,
                      cardTitle: item.cardTitle,
                      cardText: item.cardAllText,
                    });
                  }}
                >
                  <div className="card-logo">
                    <img src={item.imgUrl} alt="authing logo" />
                  </div>
                  <div className="card-title">{item.cardTitle}</div>
                  <div className="card-content">{item.cardText}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
